module.exports = __webpack_public_path__ + "img/Eurooil_logo.d26494bd.svg";